
// @ts-nocheck
import locale_cs_46json5_f880e191 from "#nuxt-i18n/f880e191";
import locale_en_46json5_de81d801 from "#nuxt-i18n/de81d801";
import locale_sk_46json5_0723d064 from "#nuxt-i18n/0723d064";
import locale_pl_46json5_bdd491c9 from "#nuxt-i18n/bdd491c9";
import locale_hu_46json5_7ede4cb9 from "#nuxt-i18n/7ede4cb9";
import locale_de_46json5_a28fc376 from "#nuxt-i18n/a28fc376";
import locale_es_46json5_254075eb from "#nuxt-i18n/254075eb";
import locale_fr_46json5_7a25a8b7 from "#nuxt-i18n/7a25a8b7";

export const localeCodes =  [
  "cs",
  "en",
  "sk",
  "pl",
  "hu",
  "de",
  "es",
  "fr"
]

export const localeLoaders = {
  cs: [
    {
      key: "locale_cs_46json5_f880e191",
      load: () => Promise.resolve(locale_cs_46json5_f880e191),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json5_de81d801",
      load: () => Promise.resolve(locale_en_46json5_de81d801),
      cache: true
    }
  ],
  sk: [
    {
      key: "locale_sk_46json5_0723d064",
      load: () => Promise.resolve(locale_sk_46json5_0723d064),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json5_bdd491c9",
      load: () => Promise.resolve(locale_pl_46json5_bdd491c9),
      cache: true
    }
  ],
  hu: [
    {
      key: "locale_hu_46json5_7ede4cb9",
      load: () => Promise.resolve(locale_hu_46json5_7ede4cb9),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json5_a28fc376",
      load: () => Promise.resolve(locale_de_46json5_a28fc376),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json5_254075eb",
      load: () => Promise.resolve(locale_es_46json5_254075eb),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json5_7a25a8b7",
      load: () => Promise.resolve(locale_fr_46json5_7a25a8b7),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/46c0cdef" /* webpackChunkName: "config_i18n_46config_46js_46c0cdef" */)
]

export const nuxtI18nOptions = {
  restructureDir: false,
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "cs",
      language: "cs",
      name: "Česky",
      icon: "custom/flag-cz",
      inInterface: true,
      files: [
        {
          path: "/vercel/path0/locales/cs.json5",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      language: "en",
      name: "English",
      icon: "custom/flag-en",
      inInterface: true,
      files: [
        {
          path: "/vercel/path0/locales/en.json5",
          cache: undefined
        }
      ]
    },
    {
      code: "sk",
      language: "sk",
      name: "Slovenčina",
      icon: "custom/flag-sk",
      files: [
        {
          path: "/vercel/path0/locales/sk.json5",
          cache: undefined
        }
      ]
    },
    {
      code: "pl",
      language: "pl",
      name: "Polski",
      icon: "custom/flag-pl",
      files: [
        {
          path: "/vercel/path0/locales/pl.json5",
          cache: undefined
        }
      ]
    },
    {
      code: "hu",
      language: "hu",
      name: "Magyar",
      icon: "custom/flag-hun",
      files: [
        {
          path: "/vercel/path0/locales/hu.json5",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      language: "de",
      name: "Deutsch",
      icon: "custom/flag-de",
      files: [
        {
          path: "/vercel/path0/locales/de.json5",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      language: "es",
      name: "Español",
      icon: "custom/flag-es",
      files: [
        {
          path: "/vercel/path0/locales/es.json5",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      language: "fr",
      name: "Français",
      icon: "custom/flag-fr",
      files: [
        {
          path: "/vercel/path0/locales/fr.json5",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: false,
  langDir: "locales/",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: false
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: true,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "cs",
    language: "cs",
    name: "Česky",
    icon: "custom/flag-cz",
    inInterface: true,
    files: [
      {
        path: "/vercel/path0/locales/cs.json5",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    language: "en",
    name: "English",
    icon: "custom/flag-en",
    inInterface: true,
    files: [
      {
        path: "/vercel/path0/locales/en.json5",
        cache: undefined
      }
    ]
  },
  {
    code: "sk",
    language: "sk",
    name: "Slovenčina",
    icon: "custom/flag-sk",
    files: [
      {
        path: "/vercel/path0/locales/sk.json5",
        cache: undefined
      }
    ]
  },
  {
    code: "pl",
    language: "pl",
    name: "Polski",
    icon: "custom/flag-pl",
    files: [
      {
        path: "/vercel/path0/locales/pl.json5",
        cache: undefined
      }
    ]
  },
  {
    code: "hu",
    language: "hu",
    name: "Magyar",
    icon: "custom/flag-hun",
    files: [
      {
        path: "/vercel/path0/locales/hu.json5",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    language: "de",
    name: "Deutsch",
    icon: "custom/flag-de",
    files: [
      {
        path: "/vercel/path0/locales/de.json5",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    language: "es",
    name: "Español",
    icon: "custom/flag-es",
    files: [
      {
        path: "/vercel/path0/locales/es.json5",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    language: "fr",
    name: "Français",
    icon: "custom/flag-fr",
    files: [
      {
        path: "/vercel/path0/locales/fr.json5",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/